import { render, staticRenderFns } from "./AltenarSportsbook.vue?vue&type=template&id=2ad3688f&"
import script from "./AltenarSportsbook.vue?vue&type=script&lang=js&"
export * from "./AltenarSportsbook.vue?vue&type=script&lang=js&"
import style0 from "./AltenarSportsbook.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/betsur.net.ar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ad3688f')) {
      api.createRecord('2ad3688f', component.options)
    } else {
      api.reload('2ad3688f', component.options)
    }
    module.hot.accept("./AltenarSportsbook.vue?vue&type=template&id=2ad3688f&", function () {
      api.rerender('2ad3688f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "themes/betsur/modules/components/pages/parts/target/AltenarSportsbook.vue"
export default component.exports